import { useMutation } from '@tanstack/react-query';
import type {
  CreateCardErrorResponseDto,
  CreateCardRequestDto,
  CreateCardResponseDto,
} from '../../model';
import { createCard } from '../requests';

interface Options {
  onSuccess?: (data: CreateCardResponseDto) => void;
  onError?: (error: CreateCardErrorResponseDto) => void;
}

export function useCreateCard({ onSuccess, onError }: Options = {}) {
  const mutation = useMutation<
    CreateCardResponseDto,
    CreateCardErrorResponseDto,
    CreateCardRequestDto
  >({
    mutationFn: args => createCard(args, { throwOriginalError: true }),
    onSuccess,
    onError,
  });

  return {
    mutate: mutation.mutate,
    mutateAsync: mutation.mutateAsync,
    data: mutation.data,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
